<div class="container">
  <div class="wrapper">
    <h1>Contact</h1>
    <p>Send your feature requests, bug reports, questions, or other ideas:</p>
    <p>Email: admin&#64;dealforager.com</p>
    <p>
      Reddit:
      <a target="_blank" href="https://www.reddit.com/r/dealforager"
        >www.reddit.com/r/dealforager</a
      >
    </p>
  </div>
</div>
